export const IbhEventCategory = 'IBH | Iglidur Bearing Hub';
export const TrackedIbhEventActions = {
  baseShape: 'Base Shape',
  switchUnitSystemSelect: 'Switch Unit System | Select',
  applicationParametersExpand: 'Application parameters | Expand',
  applicationParametersCollapse: 'Application Parameters | Collapse',
  applicationParametersCalculate: 'Application Parameters | Calculate',
  shareLink: 'Share Link',
  articleSelect: 'Article | Select',
  compareMaterialsOpen: 'Compare Materials | Open',
  removeAllFiltersSelect: 'Remove All Filters | Select',
  removeAllDimensionsSelect: 'Remove  All Dimensions | Select',
  quantity: 'Quantity',
  openQuantityDiscount: 'Open Quantity Discount',
  transferToShoppingBasket: 'Transfer To Shopping Basket',
  transferToShoppingBasketResultView: 'Transfer To Shopping Basket | Result View',
  share: 'Share',
  calculateServiceLife: 'Calculate Service Life',
  imageZoom: 'Image Zoom',
  carouselSelect: 'Carousel | Select',
  downloadsSelect: 'Downloads | Select',
  downloadsSelectResultView: 'Downloads | Select | Result View',
  serviceLifeOpen: 'Service Life | Open',
  articleSelectQR: 'Article | Select | QR',
  goToDetailView: 'Go To Detail View',
} as const;
